import { trim, toLower, find } from 'lodash'

const countries = [
  { id: 'AF', name: 'Afghanistan', nameAr: 'أفغانستان' },
  { id: 'AL', name: 'Albania', nameAr: 'ألبانيا' },
  { id: 'DZ', name: 'Algeria', nameAr: 'الجزائر' },
  { id: 'AD', name: 'Andorra', nameAr: 'أندورا' },
  { id: 'AO', name: 'Angola', nameAr: 'أنغولا' },
  { id: 'AG', name: 'Antigua and Barbuda', nameAr: 'أنتيغوا وبربودا' },
  { id: 'AR', name: 'Argentina', nameAr: 'الأرجنتين' },
  { id: 'AM', name: 'Armenia', nameAr: 'أرمينيا' },
  { id: 'AU', name: 'Australia', nameAr: 'أستراليا' },
  { id: 'AZ', name: 'Azerbaijan', nameAr: 'أذربيجان' },
  { id: 'BS', name: 'Bahamas', nameAr: 'جزر البهاما' },
  { id: 'BH', name: 'Bahrain', nameAr: 'البحرين' },
  { id: 'BD', name: 'Bangladesh', nameAr: 'بنغلاديش' },
  { id: 'BB', name: 'Barbados', nameAr: 'بربادوس' },
  { id: 'BY', name: 'Belarus', nameAr: 'بيلاروس' },
  { id: 'BE', name: 'Belgium', nameAr: 'بلجيكا' },
  { id: 'BZ', name: 'Belize', nameAr: 'بليز' },
  { id: 'BJ', name: 'Benin', nameAr: 'بنين' },
  { id: 'BT', name: 'Bhutan', nameAr: 'بوتان' },
  { id: 'BO', name: 'Bolivia', nameAr: 'بوليفيا' },
  { id: 'BA', name: 'Bosnia and Herzegovina', nameAr: 'البوسنة والهرسك' },
  { id: 'BW', name: 'Botswana', nameAr: 'بوتسوانا' },
  { id: 'BR', name: 'Brazil', nameAr: 'البرازيل' },
  { id: 'BN', name: 'Brunei', nameAr: 'بروناي' },
  { id: 'BG', name: 'Bulgaria', nameAr: 'بلغاريا' },
  { id: 'BF', name: 'Burkina Faso', nameAr: 'بوركينا فاسو' },
  { id: 'BI', name: 'Burundi', nameAr: 'بوروندي' },
  { id: 'CV', name: 'Cabo Verde', nameAr: 'الرأس الأخضر' },
  { id: 'KH', name: 'Cambodia', nameAr: 'كمبوديا' },
  { id: 'CM', name: 'Cameroon', nameAr: 'الكاميرون' },
  { id: 'CA', name: 'Canada', nameAr: 'كندا' },
  { id: 'CF', name: 'Central African Republic', nameAr: 'جمهورية أفريقيا الوسطى' },
  { id: 'TD', name: 'Chad', nameAr: 'تشاد' },
  { id: 'CL', name: 'Chile', nameAr: 'تشيلي' },
  { id: 'CN', name: 'China', nameAr: 'الصين' },
  { id: 'CO', name: 'Colombia', nameAr: 'كولومبيا' },
  { id: 'KM', name: 'Comoros', nameAr: 'جزر القمر' },
  { id: 'CD', name: 'Congo, Democratic Republic of the', nameAr: 'الكونغو - كينشاسا' },
  { id: 'CG', name: 'Congo, Republic of the', nameAr: 'الكونغو - برازافيل' },
  { id: 'CR', name: 'Costa Rica', nameAr: 'كوستاريكا' },
  { id: 'HR', name: 'Croatia', nameAr: 'كرواتيا' },
  { id: 'CU', name: 'Cuba', nameAr: 'كوبا' },
  { id: 'CY', name: 'Cyprus', nameAr: 'قبرص' },
  { id: 'CZ', name: 'Czech Republic', nameAr: 'التشيك' },
  { id: 'DK', name: 'Denmark', nameAr: 'الدانمرك' },
  { id: 'DJ', name: 'Djibouti', nameAr: 'جيبوتي' },
  { id: 'DM', name: 'Dominica', nameAr: 'دومينيكا' },
  { id: 'DO', name: 'Dominican Republic', nameAr: 'جمهورية الدومينيكان' },
  { id: 'EC', name: 'Ecuador', nameAr: 'الإكوادور' },
  { id: 'EG', name: 'Egypt', nameAr: 'مصر' },
  { id: 'SV', name: 'El Salvador', nameAr: 'السلفادور' },
  { id: 'GQ', name: 'Equatorial Guinea', nameAr: 'غينيا الاستوائية' },
  { id: 'ER', name: 'Eritrea', nameAr: 'إريتريا' },
  { id: 'EE', name: 'Estonia', nameAr: 'إستونيا' },
  { id: 'SZ', name: 'Eswatini', nameAr: 'إسواتيني' },
  { id: 'ET', name: 'Ethiopia', nameAr: 'إثيوبيا' },
  { id: 'FJ', name: 'Fiji', nameAr: 'فيجي' },
  { id: 'FI', name: 'Finland', nameAr: 'فنلندا' },
  { id: 'FR', name: 'France', nameAr: 'فرنسا' },
  { id: 'GA', name: 'Gabon', nameAr: 'الغابون' },
  { id: 'GM', name: 'Gambia', nameAr: 'غامبيا' },
  { id: 'GE', name: 'Georgia', nameAr: 'جورجيا' },
  { id: 'DE', name: 'Germany', nameAr: 'ألمانيا' },
  { id: 'GH', name: 'Ghana', nameAr: 'غانا' },
  { id: 'GR', name: 'Greece', nameAr: 'اليونان' },
  { id: 'GD', name: 'Grenada', nameAr: 'غرينادا' },
  { id: 'GT', name: 'Guatemala', nameAr: 'غواتيمالا' },
  { id: 'GN', name: 'Guinea', nameAr: 'غينيا' },
  { id: 'GW', name: 'Guinea-Bissau', nameAr: 'غينيا بيساو' },
  { id: 'GY', name: 'Guyana', nameAr: 'غيانا' },
  { id: 'HT', name: 'Haiti', nameAr: 'هايتي' },
  { id: 'HN', name: 'Honduras', nameAr: 'هندوراس' },
  { id: 'HU', name: 'Hungary', nameAr: 'هنغاريا' },
  { id: 'IS', name: 'Iceland', nameAr: 'آيسلندا' },
  { id: 'IN', name: 'India', nameAr: 'الهند' },
  { id: 'ID', name: 'Indonesia', nameAr: 'إندونيسيا' },
  { id: 'IR', name: 'Iran', nameAr: 'إيران' },
  { id: 'IQ', name: 'Iraq', nameAr: 'العراق' },
  { id: 'IE', name: 'Ireland', nameAr: 'أيرلندا' },
  { id: 'IL', name: 'Israel', nameAr: 'إسرائيل' },
  { id: 'IT', name: 'Italy', nameAr: 'إيطاليا' },
  { id: 'JM', name: 'Jamaica', nameAr: 'جامايكا' },
  { id: 'JP', name: 'Japan', nameAr: 'اليابان' },
  { id: 'JO', name: 'Jordan', nameAr: 'الأردن' },
  { id: 'KZ', name: 'Kazakhstan', nameAr: 'كازاخستان' },
  { id: 'KE', name: 'Kenya', nameAr: 'كينيا' },
  { id: 'KI', name: 'Kiribati', nameAr: 'كيريباتي' },
  { id: 'KP', name: 'Korea, North', nameAr: 'كوريا الشمالية' },
  { id: 'KR', name: 'Korea, South', nameAr: 'كوريا الجنوبية' },
  { id: 'XK', name: 'Kosovo', nameAr: 'كوسوفو' },
  { id: 'KW', name: 'Kuwait', nameAr: 'الكويت' },
  { id: 'KG', name: 'Kyrgyzstan', nameAr: 'قيرغيزستان' },
  { id: 'LA', name: 'Laos', nameAr: 'لاوس' },
  { id: 'LV', name: 'Latvia', nameAr: 'لاتفيا' },
  { id: 'LB', name: 'Lebanon', nameAr: 'لبنان' },
  { id: 'LS', name: 'Lesotho', nameAr: 'ليسوتو' },
  { id: 'LR', name: 'Liberia', nameAr: 'ليبيريا' },
  { id: 'LY', name: 'Libya', nameAr: 'ليبيا' },
  { id: 'LI', name: 'Liechtenstein', nameAr: 'ليختنشتاين' },
  { id: 'LT', name: 'Lithuania', nameAr: 'ليتوانيا' },
  { id: 'LU', name: 'Luxembourg', nameAr: 'لوكسمبورغ' },
  { id: 'MG', name: 'Madagascar', nameAr: 'مدغشقر' },
  { id: 'MW', name: 'Malawi', nameAr: 'ملاوي' },
  { id: 'MY', name: 'Malaysia', nameAr: 'ماليزيا' },
  { id: 'MV', name: 'Maldives', nameAr: 'جزر المالديف' },
  { id: 'ML', name: 'Mali', nameAr: 'مالي' },
  { id: 'MT', name: 'Malta', nameAr: 'مالطا' },
  { id: 'MH', name: 'Marshall Islands', nameAr: 'جزر مارشال' },
  { id: 'MR', name: 'Mauritania', nameAr: 'موريتانيا' },
  { id: 'MU', name: 'Mauritius', nameAr: 'موريشيوس' },
  { id: 'MX', name: 'Mexico', nameAr: 'المكسيك' },
  { id: 'FM', name: 'Micronesia', nameAr: 'ميكرونيزيا' },
  { id: 'MD', name: 'Moldova', nameAr: 'مولدوفا' },
  { id: 'MC', name: 'Monaco', nameAr: 'موناكو' },
  { id: 'MN', name: 'Mongolia', nameAr: 'منغوليا' },
  { id: 'ME', name: 'Montenegro', nameAr: 'الجبل الأسود' },
  { id: 'MA', name: 'Morocco', nameAr: 'المغرب' },
  { id: 'MZ', name: 'Mozambique', nameAr: 'موزمبيق' },
  { id: 'MM', name: 'Myanmar', nameAr: 'ميانمار (بورما)' },
  { id: 'NA', name: 'Namibia', nameAr: 'ناميبيا' },
  { id: 'NR', name: 'Nauru', nameAr: 'ناورو' },
  { id: 'NP', name: 'Nepal', nameAr: 'نيبال' },
  { id: 'NL', name: 'Netherlands', nameAr: 'هولندا' },
  { id: 'NZ', name: 'New Zealand', nameAr: 'نيوزيلندا' },
  { id: 'NI', name: 'Nicaragua', nameAr: 'نيكاراغوا' },
  { id: 'NE', name: 'Niger', nameAr: 'النيجر' },
  { id: 'NG', name: 'Nigeria', nameAr: 'نيجيريا' },
  { id: 'MK', name: 'North Macedonia', nameAr: 'مقدونيا الشمالية' },
  { id: 'NO', name: 'Norway', nameAr: 'النرويج' },
  { id: 'OM', name: 'Oman', nameAr: 'عُمان' },
  { id: 'PK', name: 'Pakistan', nameAr: 'باكستان' },
  { id: 'PW', name: 'Palau', nameAr: 'بالاو' },
  { id: 'PS', name: 'Palestine', nameAr: 'الأراضي الفلسطينية' },
  { id: 'PA', name: 'Panama', nameAr: 'بنما' },
  { id: 'PG', name: 'Papua New Guinea', nameAr: 'بابوا غينيا الجديدة' },
  { id: 'PY', name: 'Paraguay', nameAr: 'باراغواي' },
  { id: 'PE', name: 'Peru', nameAr: 'بيرو' },
  { id: 'PH', name: 'Philippines', nameAr: 'الفلبين' },
  { id: 'PL', name: 'Poland', nameAr: 'بولندا' },
  { id: 'PT', name: 'Portugal', nameAr: 'البرتغال' },
  { id: 'QA', name: 'Qatar', nameAr: 'قطر' },
  { id: 'RO', name: 'Romania', nameAr: 'رومانيا' },
  { id: 'RU', name: 'Russia', nameAr: 'روسيا' },
  { id: 'RW', name: 'Rwanda', nameAr: 'رواندا' },
  { id: 'KN', name: 'Saint Kitts and Nevis', nameAr: 'سانت كيتس ونيفيس' },
  { id: 'LC', name: 'Saint Lucia', nameAr: 'سانت لوسيا' },
  { id: 'VC', name: 'Saint Vincent and the Grenadines', nameAr: 'سانت فنسنت وجزر غرينادين' },
  { id: 'WS', name: 'Samoa', nameAr: 'ساموا' },
  { id: 'SM', name: 'San Marino', nameAr: 'سان مارينو' },
  { id: 'ST', name: 'Sao Tome and Principe', nameAr: 'ساو تومي وبرينسيبي' },
  { id: 'SA', name: 'Saudi Arabia', nameAr: 'المملكة العربية السعودية' },
  { id: 'SN', name: 'Senegal', nameAr: 'السنغال' },
  { id: 'RS', name: 'Serbia', nameAr: 'صربيا' },
  { id: 'SC', name: 'Seychelles', nameAr: 'سيشل' },
  { id: 'SL', name: 'Sierra Leone', nameAr: 'سيراليون' },
  { id: 'SG', name: 'Singapore', nameAr: 'سنغافورة' },
  { id: 'SK', name: 'Slovakia', nameAr: 'سلوفاكيا' },
  { id: 'SI', name: 'Slovenia', nameAr: 'سلوفينيا' },
  { id: 'SB', name: 'Solomon Islands', nameAr: 'جزر سليمان' },
  { id: 'SO', name: 'Somalia', nameAr: 'الصومال' },
  { id: 'ZA', name: 'South Africa', nameAr: 'جنوب أفريقيا' },
  { id: 'SS', name: 'South Sudan', nameAr: 'جنوب السودان' },
  { id: 'ES', name: 'Spain', nameAr: 'إسبانيا' },
  { id: 'LK', name: 'Sri Lanka', nameAr: 'سريلانكا' },
  { id: 'SD', name: 'Sudan', nameAr: 'السودان' },
  { id: 'SR', name: 'Suriname', nameAr: 'سورينام' },
  { id: 'SE', name: 'Sweden', nameAr: 'السويد' },
  { id: 'CH', name: 'Switzerland', nameAr: 'سويسرا' },
  { id: 'SY', name: 'Syria', nameAr: 'سوريا' },
  { id: 'TW', name: 'Taiwan', nameAr: 'تايوان' },
  { id: 'TJ', name: 'Tajikistan', nameAr: 'طاجيكستان' },
  { id: 'TZ', name: 'Tanzania', nameAr: 'تنزانيا' },
  { id: 'TH', name: 'Thailand', nameAr: 'تايلاند' },
  { id: 'TL', name: 'Timor-Leste', nameAr: 'تيمور - ليشتي' },
  { id: 'TG', name: 'Togo', nameAr: 'توغو' },
  { id: 'TO', name: 'Tonga', nameAr: 'تونغا' },
  { id: 'TT', name: 'Trinidad and Tobago', nameAr: 'ترينيداد وتوباغو' },
  { id: 'TN', name: 'Tunisia', nameAr: 'تونس' },
  { id: 'TR', name: 'Turkey', nameAr: 'تركيا' },
  { id: 'TM', name: 'Turkmenistan', nameAr: 'تركمانستان' },
  { id: 'TV', name: 'Tuvalu', nameAr: 'توفالو' },
  { id: 'UG', name: 'Uganda', nameAr: 'أوغندا' },
  { id: 'UA', name: 'Ukraine', nameAr: 'أوكرانيا' },
  { id: 'AE', name: 'United Arab Emirates', nameAr: 'الإمارات العربية المتحدة' },
  { id: 'GB', name: 'United Kingdom', nameAr: 'المملكة المتحدة' },
  { id: 'US', name: 'United States', nameAr: 'الولايات المتحدة' },
  { id: 'UY', name: 'Uruguay', nameAr: 'أورغواي' },
  { id: 'UZ', name: 'Uzbekistan', nameAr: 'أوزبكستان' },
  { id: 'VU', name: 'Vanuatu', nameAr: 'فانواتو' },
  { id: 'VA', name: 'Vatican City', nameAr: 'الفاتيكان' },
  { id: 'VE', name: 'Venezuela', nameAr: 'فنزويلا' },
  { id: 'VN', name: 'Vietnam', nameAr: 'فيتنام' },
  { id: 'YE', name: 'Yemen', nameAr: 'اليمن' },
  { id: 'ZM', name: 'Zambia', nameAr: 'زامبيا' },
  { id: 'ZW', name: 'Zimbabwe', nameAr: 'زيمبابوي' },
]

const normalizeValue = value => (value ? toLower(trim(value.toString())) : '')

export const getLocalizedCountries = (language = 'en') => {
  const isArabic = language === 'ar'
  return countries.map(country => ({
    ...country,
    name: isArabic ? country.nameAr || country.name : country.name,
  }))
}

export const getCountryDisplayName = (value, language = 'en') => {
  if (!value) return ''
  const normalizedInput = normalizeValue(value)
  const country = find(countries, item => {
    return normalizeValue(item.id) === normalizedInput || normalizeValue(item.name) === normalizedInput || normalizeValue(item.nameAr) === normalizedInput
  })

  if (!country) {
    return value
  }

  return language === 'ar' ? country.nameAr || country.name : country.name
}

export default countries
